import { render, staticRenderFns } from "./PlannedLeaveTable.vue?vue&type=template&id=71933429&scoped=true"
import script from "./PlannedLeaveTable.vue?vue&type=script&lang=js"
export * from "./PlannedLeaveTable.vue?vue&type=script&lang=js"
import style0 from "./PlannedLeaveTable.vue?vue&type=style&index=0&id=71933429&prod&lang=scss&scoped=true"
import style1 from "./PlannedLeaveTable.vue?vue&type=style&index=1&id=71933429&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71933429",
  null
  
)

export default component.exports